import { render } from "./DataMapperInvocations.vue?vue&type=template&id=179944cb&scoped=true"
import script from "./DataMapperInvocations.vue?vue&type=script&lang=js"
export * from "./DataMapperInvocations.vue?vue&type=script&lang=js"

import "./DataMapperInvocations.vue?vue&type=style&index=0&id=179944cb&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179944cb"]])

export default __exports__